import { useState } from 'react';
import { observer } from "mobx-react";
import { CloseSquare } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, TextField, Alert, Typography } from "@mui/material";
import styles from './settings.module.scss';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '../../icons/save-icon.png'
import ChangeEmailSchema from '../shared/forms-schemas/change-email-schema';
import { useFormik } from 'formik';
import PasswordField from "../shared/components/password-field";
import Countdown from '../shared/components/countdown';

const ChangeEmailModal = observer(({ show, setShow, uiStore, update }) => {
    const { error } = uiStore;
    const [loading, setLoading] = useState(false);
    const [showVerify, setShowVerifiy] = useState(false);
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: ChangeEmailSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const res = await uiStore.changeEmail(values);
            if (res) {
                setEmail(values.email);
                setShowVerifiy(true);
                values.email = '';
                values.password = '';
            }
            setLoading(false);
        },
    });

    const verify = async () => {
        setLoading(true);
        const res = await uiStore.acceptEmailRequest(code, email);
        if (res) {
            setShow(false);
            update();
            setCode('')
            setEmail('')
            setShowVerifiy(false);
        }
        setLoading(false);
    }

    return (
        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                Change Email address
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                {error &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }
                {showVerify ?
                    <Box
                        component="form"
                        className={styles.formBox}
                    >
                        <Typography sx={{ textAlign: 'left' }}>
                            Enter verification code found in Email Address
                        </Typography>
                        <Typography sx={{ lineHeight: 0 }} fontWeight={500}>
                            {email}
                        </Typography>
                        <Alert severity="info" sx={{ textAlign: 'left', mt: 0 }}>
                            Please check spam folder for verification Email.
                        </Alert>

                        <TextField
                            required
                            id="code"
                            label="Verification code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />

                        <Countdown time={300} />

                        <LoadingButton variant="contained" color="secondary"
                            endIcon={<img src={SaveIcon}
                                alt='Save icon'
                                width={24}
                            />}
                            loading={loading}
                            onClick={verify}
                        >
                            Save
                        </LoadingButton>
                    </Box>
                    :
                    <>
                        <Alert severity="info" sx={{ textAlign: 'left' }}>
                            Please note that if you change your email address, you will no longer be able to log in using your old email. <br />
                        </Alert>
                        <Alert severity="warning" sx={{ textAlign: 'left' }}>
                            You can only change you email address twice.
                        </Alert>
                        <Box
                            component="form"
                            className={styles.formBox}
                            onSubmit={formik.handleSubmit}
                        >

                            <PasswordField
                                required
                                id="password"
                                label="Password"
                                formik={formik}
                            />

                            <TextField
                                required
                                id="email"
                                label="New Email Address"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <LoadingButton variant="contained" color="secondary"
                                    endIcon={<img src={SaveIcon}
                                        alt='Save icon'
                                        width={24}
                                    />}
                                    loading={loading}
                                    type='submit'
                                >
                                    Save
                                </LoadingButton>
                            </Box>
                        </Box>
                    </>}
            </DialogContent>


        </Dialog >
    );
});

export default ChangeEmailModal;
